import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonComponent, HeadingComponent, TextareaComponent } from '@core/user-interface-legacy';

import { TextInputPayload, TextInputResume } from '../schemas';

@Component({
  selector: 'tellent-assistant-text-input-interrupt',
  standalone: true,
  imports: [ReactiveFormsModule, TextareaComponent, ButtonComponent, HeadingComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-heading variant="subheading" class="prompt">{{ payload().prompt }}</rt-heading>
    <rt-textarea
      [formControl]="control"
      [placeholder]="payload().placeholder ?? ''"
      [autoHeight]="true"
      [maxHeight]="160"
    />
    @if (!resolved()) {
      <footer class="actions">
        <rt-button
          variant="primary"
          size="small"
          [disabled]="control.invalid || !control.value.trim()"
          (click)="submit()"
        >
          Send
        </rt-button>
      </footer>
    }
  `,
  styleUrls: ['./text-input-interrupt.component.less'],
})
export class TellentAssistantTextInputInterruptComponent {
  public readonly payload = input.required<TextInputPayload>();
  public readonly resolved = input<boolean>(false);
  public readonly resolve = output<TextInputResume>();
  public readonly cancel = output<void>();

  protected readonly control = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required],
  });

  protected submit(): void {
    const answer = this.control.value.trim();
    if (!answer) return;
    this.resolve.emit({ answer });
    this.control.reset('');
  }
}
